import { Navigate, useLocation } from "react-router-dom";
import type { ReactNode } from "react";
import { useAuth } from "../lib/auth";
import type { CurrentUser } from "../lib/types";
import { LoadingScreen } from "./LoadingScreen";

export function ProtectedRoute({ children, allow }:
  { children: ReactNode; allow?: (u: CurrentUser) => boolean }) {
  const { user, loading } = useAuth();
  const loc = useLocation();
  if (loading) return <LoadingScreen label="Preparing your workspace" />;
  if (!user) return <Navigate to="/login" state={{ from: loc.pathname }} replace />;
  if (allow && !allow(user)) return <div className="main"><div className="card empty">You don't have access to this page.</div></div>;
  return <>{children}</>;
}
